import React from 'react';
import PropTypes from 'prop-types';

import LoadingButton from "components/LoadingButton";
import StripePaymentSubForm from './StripePaymentSubForm';
import getPublishableKey from 'utils/getPublishableKey';
import "./stripe.css"

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { t } from 'i18n/index';


const StripePaymentModal = ({ gift,
                              finalPrice,
                              currencySymbol,
                              clientSecret,
                              organizationId,
                              handleStep,
                              handleMessage,
                              handleErrorFindingReward,
                           }) => {

  const stripePromise = loadStripe(getPublishableKey(organizationId, 'stripe'), {locale: 'auto'});

  const appearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#e55e29',
    },
  };
  
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div>
      {clientSecret ? 
        <Elements options={options} stripe={stripePromise}>
          <StripePaymentSubForm gift={ gift }
                                finalPrice={ finalPrice }
                                currencySymbol={ currencySymbol }
                                handleStep={ handleStep }
                                handleMessage={ handleMessage }
                                handleErrorFindingReward={ handleErrorFindingReward }
                                />
        </Elements>
      :
        <>
          <p>{t('checkoutForm:preparingYourOrder')}</p>
          <LoadingButton />
        </>
      }
    </div>
  );
}

StripePaymentModal.propTypes = {
  gift: PropTypes.bool,
  finalPrice: PropTypes.number,
  currencySymbol: PropTypes.string,
  clientSecret: PropTypes.string,
  organizationId: PropTypes.number,
  handleStep: PropTypes.func,
  handleMessage: PropTypes.func,
  handleErrorFindingReward: PropTypes.func,
};


export default StripePaymentModal;